// src/components/FacilityWaitlistForm.js
import React, { useState } from 'react';
import { Container, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import emailjs from 'emailjs-com';

const FacilityWaitlistForm = () => {
  const [formData, setFormData] = useState({
    facilityName: '',
    contactName: '',
    email: '',
    phone: '',
    location: '',
    notes: '',
  });
  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus({ submitted: false, submitting: true, info: { error: false, msg: null } });

    // Template parameters for EmailJS – adjust keys to match your email template.
    const templateParams = {
      facilityName: formData.facilityName,
      contactName: formData.contactName,
      email: formData.email,
      phone: formData.phone,
      location: formData.location,
      notes: formData.notes,
      // Optional: you can include the Calendly link as a parameter if your template uses it.
      calendlyLink: 'https://calendly.com/eli-rxrooster?duration=30min'
    };

    const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    // Create a new EmailJS template for waitlist submissions.
    const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID_FACILITY_WAITLIST;
    const userID = process.env.REACT_APP_EMAILJS_USER_ID;

    if (!serviceID || !templateID || !userID) {
      console.error('EmailJS environment variables are missing.');
      setStatus({
        submitted: true,
        submitting: false,
        info: { error: true, msg: 'Internal configuration error. Please try again later.' },
      });
      return;
    }

    emailjs.send(serviceID, templateID, templateParams, userID)
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        setStatus({
          submitted: true,
          submitting: false,
          info: { error: false, msg: 'Congratulations! You have joined the facility waitlist. Check your email for details and a link to schedule a meeting with Eli if needed.' },
        });
        // Reset the form after submission
        setFormData({
          facilityName: '',
          contactName: '',
          email: '',
          phone: '',
          location: '',
          notes: '',
        });
      })
      .catch((err) => {
        console.error('FAILED...', err);
        setStatus({
          submitted: true,
          submitting: false,
          info: { error: true, msg: 'Failed to send your submission. Please try again later.' },
        });
      });
  };

  return (
    <Container className="my-5">
      <h2 className="text-center mb-4" data-aos="fade-up">Join the Facility Waitlist</h2>
      <Form onSubmit={handleSubmit} data-aos="fade-up">
        <Row>
          <Col md={6}>
            <Form.Group controlId="formFacilityName" className="mb-3">
              <Form.Label>Facility Name*</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your facility name"
                name="facilityName"
                value={formData.facilityName}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="formContactName" className="mb-3">
              <Form.Label>Contact Person*</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter contact person's name"
                name="contactName"
                value={formData.contactName}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Group controlId="formEmail" className="mb-3">
              <Form.Label>Email*</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter contact email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="formPhone" className="mb-3">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="tel"
                placeholder="e.g., +1234567890"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>
        <Form.Group controlId="formLocation" className="mb-3">
          <Form.Label>Location</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter the facility location"
            name="location"
            value={formData.location}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group controlId="formNotes" className="mb-3">
          <Form.Label>Additional Notes</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            placeholder="Enter any additional details or notes"
            name="notes"
            value={formData.notes}
            onChange={handleChange}
          />
        </Form.Group>
        <Button variant="primary" type="submit" disabled={status.submitting} className="mt-3">
          {status.submitting ? 'Submitting...' : 'Join Waitlist'}
        </Button>
      </Form>
      {status.submitted && status.info.msg && (
        <Alert
          variant={status.info.error ? 'danger' : 'success'}
          className="mt-4 text-center"
          dismissible
          onClose={() => setStatus({ ...status, info: { error: false, msg: null } })}
        >
          {status.info.msg}
        </Alert>
      )}
    </Container>
  );
};

export default FacilityWaitlistForm;
